import React from 'react'
import {FormattedMessage} from 'react-intl'
import {Stack, Box, Text, Link} from '@salesforce/retail-react-app/app/components/shared/ui'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import PropTypes from 'prop-types'
import {KS_PERSONAL_SHOPPING_SESSION_URL} from '../../../constants'

const NoSearchResults = ({hideNoSearchResults = false}) => {
    const {
        app: {commerceAPI}
    } = getConfig()
    const {hostUrl} = commerceAPI.storefront
    const url = hostUrl + KS_PERSONAL_SHOPPING_SESSION_URL

    return (
        <Stack
            gap="5px"
            display={hideNoSearchResults ? 'none' : 'block'}
            textAlign="center"
            color="black"
            fontSize="14px"
            fontWeight="300"
            lineHeight="20px"
            letterSpacing="0.5px"
        >
            <Text fontWeight="500">
                <FormattedMessage
                    id="select_store_modal.no_locations_nearby"
                    defaultMessage="No Locations Nearby"
                />
            </Text>

            <Text>
                <FormattedMessage
                    id="select_store_modal.there_are_no_stores_within_100_miles_of_you"
                    defaultMessage="There are no stores within 100 miles of you."
                />
            </Text>

            <Text>
                <FormattedMessage
                    id="select_store_modal.if_you_would_like_individualized_styling_advice_you_can_book_a_virtual_personal_shopping_session"
                    defaultMessage="If you would like individualized styling advice, you can book a virtual personal shopping session."
                />
            </Text>

            <Box>
                <Link href={url} variant="underline">
                    <FormattedMessage id="select_store_modal.book_now" defaultMessage="Book Now" />
                </Link>
            </Box>
        </Stack>
    )
}

NoSearchResults.propTypes = {
    hideNoSearchResults: PropTypes.any
}
export default NoSearchResults
